import type { AppThunk } from 'state';
import DataServiceDataCountries from 'common/dataService/services/dataCountries';
import FetchingStatus from 'constants/statuses/FetchingStatus';
import { setFetching, setDataCountries } from '../slice';

function fetchDataCountries(): AppThunk {
  return async function fetchDataCountriesThunk(dispatch, getState) {
    try {
      const { fetching } = getState().dataService.dataCountries;

      if (fetching === FetchingStatus.InProgress) {
        return;
      }

      dispatch(setFetching(FetchingStatus.InProgress));

      const data = await DataServiceDataCountries.getDataCountries();

      if (!data) {
        dispatch(setFetching(FetchingStatus.Failed));
        return;
      }

      dispatch(setDataCountries(data));
      dispatch(setFetching(FetchingStatus.Succeeded));
    } catch (error) {
      dispatch(setFetching(FetchingStatus.Failed));
      window.Rollbar.error(error);
    }
  };
}

export default fetchDataCountries;
